import { MutableRefObject, useEffect } from 'react'

export const useFormModify = (formId: string, onModify?: () => void) => {
  useEffect(() => {
    const handleChange = (event: Event) => {
      const target = event.target

      if (target && 'form' in target) {
        const targetForm = target.form
        if (targetForm instanceof HTMLFormElement && 'id' in targetForm) {
          if (targetForm.id === formId) onModify?.()
        }
      }
    }

    document.addEventListener('change', handleChange)
    return () => document.removeEventListener('change', handleChange)
  }, [onModify])
}
